import React from 'react';
import {
  CartesianGrid,
  XAxis,
  YAxis,
  ResponsiveContainer,
  ScatterChart,
  Scatter,
  Tooltip,
} from 'recharts';
import { InSpecIcon, OutOfSpecIcon } from '../Common/Icons';
import { expandCamelCase, nearestUp, nearestDown } from '../../utils/formatter';
// import { useForm, Controller } from 'react-hook-form';
// import { Form, Row, Col } from 'react-bootstrap';

const CustomizedShape = (props) => {
  const { cx, cy, payload, selectConcept } = props;

  return (
    <svg
      x={cx - 7}
      y={cy - 7}
      width={14}
      height={14}
      viewBox="0 0 1024 1024"
      onClick={() => {
        selectConcept(payload.conceptName);
      }}
      className="hoverable"
    >
      {payload.inSpec ? <InSpecIcon /> : <OutOfSpecIcon />}
    </svg>
  );
};

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length > 1) {
    const designName = payload[0].payload.conceptName;
    const revisionNumber = payload[0].value;

    const performanceField = payload[1].name;
    const performanceValue = payload[1].value;

    return (
      <div className="bg-white border border-rounded p-2 border-primary">
        <strong>
          {designName} - {revisionNumber}
        </strong>
        <br />
        {performanceField}: {performanceValue}
      </div>
    );
  }

  return <></>;
};

const LogsForSpecification = ({
  designFields,
  concepts,
  width,
  selectedSpecName,
  selectConcept,
}) => {
  const [hoveredConcept, setHoveredConcept] = React.useState();
  const [selectedDesignField, setSelectedDesignField] = React.useState(
    expandCamelCase(designFields[0])
  );
  // const { control } = useForm();

  const revisions = concepts.map((c) => ({
    name: c.name,
    data: c.revisions
      .filter((revision) => revision.performance > 0)
      .filter((revision) => revision.diagnostics)
      .map((revision) => ({
        id: revision.id,
        conceptName: c.name,
        name: `R${revision.revision}`,
        inSpec:
          revision.diagnostics.find((d) => d.label === 'Specifications')
            ?.value === 'In Spec',

        Revision: revision.revision,

        ...Object.fromEntries(
          designFields.map((f) => [expandCamelCase(f), parseFloat(revision[f])])
        ),
      }))
      .toSorted((a, b) => a.Revision - b.Revision),
  }));

  return (
    <>
      <h4 className="p-3 mb-0">
        <strong>All Concepts:</strong> {selectedSpecName}
      </h4>

      {/*designFields.length > 1 && (
        <div style={{ 'margin-left': '60px' }}>
          <Row className="mx-0 align-items-center">
            <Col xs="auto" className="px-0">
              <Form.Label column="sm" htmlFor="yAxisField">
                Y-Axis:
              </Form.Label>
            </Col>
            <Col xs="auto" className="pe-0 ps-1">
              <Controller
                name="yAxisField"
                control={control}
                render={({ field }) => (
                  <Form.Select size="sm" {...field}>
                    {designFields.map((f) => (
                      <option value={expandCamelCase(f)} key={f}>
                        {expandCamelCase(f)}
                      </option>
                    ))}
                  </Form.Select>
                )}
              />
            </Col>
          </Row>
        </div>
      )*/}

      <div style={width ? { width } : undefined}>
        <ResponsiveContainer width="100%" height={250}>
          <ScatterChart margin={{ left: 0, right: 30, top: 10, bottom: 10 }}>
            <CartesianGrid />
            <XAxis
              type="category"
              allowDuplicatedCategory={false}
              dataKey="name"
            />
            <YAxis
              type="number"
              dataKey={selectedDesignField}
              domain={[
                (min) => nearestDown(Math.floor(min * 95) / 100, 0.5),
                (max) => nearestUp(Math.ceil(max * 105) / 100, 0.5),
              ]}
            />
            <Tooltip cursor={false} content={<CustomTooltip />} />

            {revisions &&
              revisions.map((r) => (
                <Scatter
                  key={r.name}
                  name={r.name}
                  data={r.data}
                  shape={<CustomizedShape selectConcept={selectConcept} />}
                  line={{ strokeWidth: 2 }}
                  fill={hoveredConcept === r.name ? '#337ab7' : '#666'}
                  onMouseOver={({ payload }) =>
                    setHoveredConcept(payload?.conceptName)
                  }
                  onMouseOut={() => setHoveredConcept(undefined)}
                />
              ))}
          </ScatterChart>
        </ResponsiveContainer>

        <div className="d-flex justify-content-center text-muted">
          Click on a concept to see details
        </div>
      </div>
    </>
  );
};

export default LogsForSpecification;
